import React from 'react'

interface Properties {
    title: string
    dates: string
    company: string
    location?: string
    children?: React.ReactNode
}

// Console-tile chamfer: one 14px top-right cut (clip-path — the border won't follow the cut edge)
const TILE_CHAMFER = 'polygon(0 0,calc(100% - 14px) 0,100% 14px,100% 100%,0 100%)'

export default function Entry({title, dates, company, location, children}: Properties) {
    return (
        <div
            className="print-avoid-break group relative border border-line bg-panel px-5 py-5 md:px-6 font-body text-body transition-colors duration-150 hover:border-accent"
            style={{clipPath: TILE_CHAMFER}}
        >
            <span className="absolute left-0 top-0 h-full w-[3px] bg-gradient-to-b from-primary to-accent-violet" />

            <span className="entry-index font-mono text-[10px] tracking-[.2em] text-faint" />

            <div className="mt-1.5 flex flex-col sm:flex-row sm:justify-between sm:items-start gap-2">
                <h3 className="font-display font-bold uppercase tracking-[.04em] text-lg leading-tight text-ink">
                    {title}
                </h3>
                <span className="self-start border border-line bg-well px-2 py-[3px] font-mono text-[10px] tracking-[.15em] text-mute whitespace-nowrap">
                    {dates}
                </span>
            </div>
            <div className="mt-0.5 flex flex-col sm:flex-row sm:justify-between sm:items-start gap-1">
                <span className="font-display font-semibold uppercase tracking-[.12em] text-accent">
                    {company}
                </span>
                {location && (
                    <span className="font-mono text-[10px] tracking-[.15em] uppercase text-mute">
                        {location}
                    </span>
                )}
            </div>
            {children && (
                <div className="mt-3 border-t border-line pt-3 text-sm font-medium leading-relaxed">
                    {children}
                </div>
            )}
        </div>
    )
}
